export const Urls = {
  APPOINTMENT_TYPE: `/steps/appointment-type`,
  INSURANCE: `/steps/insurance`,
  SCHEDULE_EXAM: `/steps/schedule-exam`,
  PATIENT_DETAILS: `/steps/patient-details`,
  CUSTOM_PAGE: `/steps/custom-page`,
  CONTACT_DETAILS: `/steps/contact-details`,
  STEPS: `/steps`,
  TYP: `/typ`,
  MANAGE: `/manage`,

  RESCHEDULE_SCHEDULE_EXAM: `/reschedule/schedule-exam`,
  RESCHEDULE_CONFIRMED: `/reschedule/confirmed`,
  RESCHEDULE: `/reschedule`,

  PRACTICE_CARD: `/practice`,
};
